document.addEventListener('DOMContentLoaded', function () {
  // 直接遷移時の処理を安定化するため、少し遅延を追加
  setTimeout(() => {
    initializeColorFilter();
  }, 50);
  
  function initializeColorFilter() {
    applyColorFilter();
    attachSwitchEvents();
  }
  
  function applyColorFilter() {
    requestAnimationFrame(() => {
      const colorVariantItems = document.querySelectorAll('li[data-wds-variant="true"]');
      const defaultItems = document.querySelectorAll('li[data-wds-variant="false"]');
      const desktopSwitch = document.getElementById('colorFilterSwitchWDS');
      const spSwitch = document.getElementById('colorFilterSwitchWDS_SP');
      const isViewAll = localStorage.getItem('wds_show_all_colors') === 'true';

      // イベントリスナーを一時的に無効化して無限ループを防ぐ
      const isUpdatingSwitches = true;

      if (isViewAll) {
        console.log("Applying View All Colors (ON)");
        if (desktopSwitch) {
          // イベントリスナーを一時的に削除
          if (window.wdsDesktopSwitchHandler) {
            desktopSwitch.removeEventListener('change', window.wdsDesktopSwitchHandler);
          }
          desktopSwitch.checked = true;
          // イベントリスナーを再追加
          if (window.wdsDesktopSwitchHandler) {
            desktopSwitch.addEventListener('change', window.wdsDesktopSwitchHandler);
          }
        }
        if (spSwitch) {
          // イベントリスナーを一時的に削除
          if (window.wdsSpSwitchHandler) {
            spSwitch.removeEventListener('change', window.wdsSpSwitchHandler);
          }
          spSwitch.checked = true;
          // イベントリスナーを再追加
          if (window.wdsSpSwitchHandler) {
            spSwitch.addEventListener('change', window.wdsSpSwitchHandler);
          }
        }
        colorVariantItems.forEach((item) => item.style.display = 'block');
        defaultItems.forEach((item) => item.style.display = 'none');
      } else {
        console.log("Applying Default Items (OFF)");
        if (desktopSwitch) {
          // イベントリスナーを一時的に削除
          if (window.wdsDesktopSwitchHandler) {
            desktopSwitch.removeEventListener('change', window.wdsDesktopSwitchHandler);
          }
          desktopSwitch.checked = false;
          // イベントリスナーを再追加
          if (window.wdsDesktopSwitchHandler) {
            desktopSwitch.addEventListener('change', window.wdsDesktopSwitchHandler);
          }
        }
        if (spSwitch) {
          // イベントリスナーを一時的に削除
          if (window.wdsSpSwitchHandler) {
            spSwitch.removeEventListener('change', window.wdsSpSwitchHandler);
          }
          spSwitch.checked = false;
          // イベントリスナーを再追加
          if (window.wdsSpSwitchHandler) {
            spSwitch.addEventListener('change', window.wdsSpSwitchHandler);
          }
        }
        colorVariantItems.forEach((item) => item.style.display = 'none');
        defaultItems.forEach((item) => item.style.display = 'block');
      }
    });
  }

  if (localStorage.getItem('wds_show_all_colors') === null) {
    localStorage.setItem('wds_show_all_colors', 'true');
  }

  function syncSwitches(isChecked) {
    // 処理中フラグをチェックして無限ループを防ぐ
    if (window.wdsSyncProcessing) {
      return;
    }
    
    window.wdsSyncProcessing = true;
    localStorage.setItem('wds_show_all_colors', isChecked ? 'true' : 'false');
    
    // 遅延を追加してイベントの競合を防ぐ
    setTimeout(() => {
      applyColorFilter();
      window.wdsSyncProcessing = false;
    }, 50);
  }

  function attachSwitchEvents() {
    const desktopSwitch = document.getElementById('colorFilterSwitchWDS');
    const spSwitch = document.getElementById('colorFilterSwitchWDS_SP');

    // 既存のイベントリスナーを削除してから新しいものを追加
    if (desktopSwitch) {
      // 既存のイベントリスナーを削除
      if (window.wdsDesktopSwitchHandler) {
        desktopSwitch.removeEventListener('change', window.wdsDesktopSwitchHandler);
      }
      // 新しいイベントリスナーを作成
      window.wdsDesktopSwitchHandler = function () {
        syncSwitches(desktopSwitch.checked);
      };
      // イベントリスナーを追加
      desktopSwitch.addEventListener('change', window.wdsDesktopSwitchHandler);
      console.log('Desktop switch event listener attached');
    }

    if (spSwitch) {
      // 既存のイベントリスナーを削除
      if (window.wdsSpSwitchHandler) {
        spSwitch.removeEventListener('change', window.wdsSpSwitchHandler);
      }
      // 新しいイベントリスナーを作成
      window.wdsSpSwitchHandler = function () {
        syncSwitches(spSwitch.checked);
      };
      // イベントリスナーを追加
      spSwitch.addEventListener('change', window.wdsSpSwitchHandler);
      console.log('SP switch event listener attached');
    }
  }

  function reapplyColorFilterWithDelay() {
    // リロードループを防ぐため、処理中フラグを使用
    if (window.wdsColorFilterProcessing) {
      return;
    }
    
    window.wdsColorFilterProcessing = true;
    
    // デバウンス処理を追加して頻繁な実行を防ぐ
    if (window.wdsColorFilterTimeout) {
      clearTimeout(window.wdsColorFilterTimeout);
    }
    
    window.wdsColorFilterTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        applyColorFilter();
        // フィルター更新後にスイッチのイベントリスナーを再設定
        attachSwitchEvents();
        window.wdsColorFilterProcessing = false;
        window.wdsColorFilterTimeout = null;
      });
    }, 150); // 遅延時間をさらに増やして安定性を向上
  }

  // イベントリスナーの重複登録を防ぐ
  if (!window.wdsEventListenersAttached) {
    document.addEventListener('facets:updated', reapplyColorFilterWithDelay);
    document.addEventListener('facets-filter:rendered', reapplyColorFilterWithDelay);
    document.addEventListener('infinite-scroll:updated', applyColorFilter);
    
    // MutationObserverでスイッチの再作成を監視
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // スイッチが追加された場合、イベントリスナーを再設定
              if (node.id === 'colorFilterSwitchWDS' || node.id === 'colorFilterSwitchWDS_SP' || 
                  node.querySelector && (node.querySelector('#colorFilterSwitchWDS') || node.querySelector('#colorFilterSwitchWDS_SP'))) {
                setTimeout(() => {
                  attachSwitchEvents();
                }, 100);
              }
            }
          });
        }
      });
    });
    
    // ドキュメント全体を監視
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    window.wdsEventListenersAttached = true;
  }
});

